import React, { Component } from 'react';
import { Router, Route, hashHistory } from 'react-router';
import Login from './components/Login/Login';
import Chat from './components/Chat/HomePage';
import AnswerPage from './components/Chat/QuestionPage';
import Dashboard from './components/Dashboard/Dashboard';
import Articles from './components/Articles/Articles';
import AddArticles from './components/Articles/AddArticles';
import PushArticles from './components/Articles/PushArticles';
import Products from './components/Products/Products';
import AddProducts from './components/Products/AddProducts';
import Events from './components/Events/Events';
import AddEvents from './components/Events/AddEvents';
import UserDetails from './components/UserDetails/UserDetails';
import Campaign from './components/Campaign/Campaign';
import Gallery from './components/Campaign/Gallery';
import UserImages from './components/Campaign/UserImages';

export default class Routes extends Component {
    render() {
        return (
            <Router history={hashHistory}>
                <Route path="/" component={Login} />
                <Route path="dashboard" component={Dashboard} />
                <Route path="chat" component={Chat} />
                <Route path="Chat/Answers" component={AnswerPage} />
                <Route path="articles" component={Articles} />
                <Route path="articles/add_articles" component={AddArticles} />
                <Route path="articles/add_articles/push" component={PushArticles} />
                <Route path="products" component={Products} />
                <Route path="add_products" component={AddProducts} />
                <Route path="events" component={Events} />
                <Route path="add_events" component={AddEvents} />
                <Route path="userdetails" component={UserDetails} />
                <Route path="campaign" component={Campaign} />
                <Route path="campaign/gallery" component={Gallery} />
                <Route path="campaign/gallery/user_images" component={UserImages} />
            </Router>
        );
    }
}



// WEBPACK FOOTER //
// ./src/routes.js